export default __webpack_public_path__ + "c929e5e708ea0bb388a9d71013e9d3c6.jpg";